module.exports = __webpack_public_path__ + "static/media/cq_richieste_in_corso b.564ba793.svg";